// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fff84645","455":"279c3b56","977":"61e99824"}[chunkId] + ".chunk.js";
};